import ProductItem from "./productItem";

const ProductsList = ({ products, status }) => {

  return (
    <div>
      <div className="product-list-item-wrapper row">
        {status ? (
          status
        ) : (
          products.map((product) => (
            <ProductItem key={product.id} {...product} />
          ))
        )}
      </div>
    </div>
  );
};

export default ProductsList;
